import {
  EMAIL_ACTION_ATTACH_REQUEST,
  EMAIL_ACTION_COPY_TO,
  EMAIL_ACTION_COPY_TO_DELETE,
  EMAIL_PROFILE_ACTION_MESSAGE_RESEND,
} from '../../Email.constants'

export const EMAIL_PROFILE_ACTIONS_MESSAGE_SUCCESS_TITLE = {
  [EMAIL_ACTION_ATTACH_REQUEST]:
    'Notification.EmailProfileMessageHeaderActionTitleAttachRequestKey',
  [EMAIL_ACTION_COPY_TO]:
    'Notification.EmailProfileMessageHeaderActionTitleCopyToEntityKey',
  [EMAIL_ACTION_COPY_TO_DELETE]:
    'Notification.EmailProfileMessageActionTitleRemoveCopyToEntityKey',
  [EMAIL_PROFILE_ACTION_MESSAGE_RESEND]:
    'Notification.EmailProfileMessageHeaderActionTitleResendKey',
}

export const EMAIL_PROFILE_ACTIONS_MESSAGE_ERROR_TITLE = {
  [EMAIL_ACTION_ATTACH_REQUEST]:
    'Notification.EmailProfileMessageErrorTitleAttachRequestKey',
  [EMAIL_ACTION_COPY_TO]:
    'Notification.EmailProfileMessageActionErrorTitleCopyToEntityKey',
  [EMAIL_ACTION_COPY_TO_DELETE]:
    'Notification.EmailProfileMessageActionErrorTitleRemoveCopyToEntityKey',
  [EMAIL_PROFILE_ACTION_MESSAGE_RESEND]:
    'Notification.EmailProfileMessageActionErrorTitleResendKey',
}
